import React from 'react';
import Select from 'react-select';
import { reactSelectAtsComponents } from 'ats/components/react-select/reactSelectAtsComponents';

export default function DropdownSearchable({
	value,
	placeholder,
	onChange,
	options,
	classNamePrefix,
	styleVersion,
	customStyles,
	isMulti,
	isClearable,
	disabled
}) {
	return (
		<Select
			value={value}
			placeholder={placeholder}
			onChange={onChange}
			options={options}
			classNamePrefix={
				classNamePrefix ||
				'react-select' + (styleVersion ? `-${styleVersion}` : '')
			}
			maxMenuHeight="300"
			className={'react-select ' + (styleVersion ? styleVersion : '')}
			cacheOptions
			isMulti={isMulti}
			isClearable={isClearable}
			isDisabled={disabled}
			components={reactSelectAtsComponents}
			styles={{
				container: (base, state) => ({
					...base,
					...(state.isDisabled && {
						opacity: 0.5,
						cursor: 'not-allowed'
					})
				}),
				control: base => ({
					...base,
					...(customStyles?.control || {})
				})
			}}
			menuPosition="fixed"
		/>
	);
}
